import React from 'react'
import {
  Container,
  Icon,
  Grid,
  Button,
  Segment,
  Header,
  Image
} from 'semantic-ui-react'
import Diagram from './Diagram';

import {FormattedMessage} from 'react-intl';

import sound1accDE from "./de/1.m4a";
import sound2accDE from "./de/2.m4a";
import sound3accDE from "./de/3.m4a";
import sound4accDE from "./de/4.m4a";
import sound5accDE from "./de/5.m4a";
import sound6accDE from "./de/6.m4a";
import sound7accDE from "./de/7.m4a";
//import sound8accDE from "./de/sound8.m4a";

/*
import sound1accEN from "./en/sound1.m4a";
import sound2accEN from "./en/sound2.m4a";
import sound3accEN from "./en/sound3.m4a";
import sound4accEN from "./en/sound4.m4a";
import sound5accEN from "./en/sound5.m4a";
import sound6accEN from "./en/sound6.m4a";
import sound7accEN from "./en/sound7.m4a";
*/

const dataAryDE = [
  {id: 1, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/1.mp3", question: 'Was antwortest du?', answers: ['„Wir gehen querfeldein“', 1, 2, '„Wir schleichen uns durchs Dorf“', 2, 3]},
  {id: 2, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/2.mp3", question: '"Was machen wir jetzt?"', answers: ['Du bittest Pixel, gegen den Nachtwandler zu kämpfen ', 3, 4,'Du bittest Maffi, gegen den Nachtwandler zu kämpfen ', 4, 5,'Du fliehst', 5, 6]},
  {id: 3, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/3.mp3", question: 'Zufallsentscheidung!', answers: ['Würfeln', 7, 7]},
  {id: 4, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/4.mp3"},
  {id: 5, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/5.mp3"},
  {id: 6, audio: "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/6.mp3"},
  {id: 7, audio: null},
];

const randomAudios = [
  "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/7.mp3",
  "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/8.mp3",
  "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/9.mp3",
  "https://audory-static.s3.eu-central-1.amazonaws.com/interactiveExample/10.mp3"
];

/*
const dataAryDE = [
  {id: 1, audio: sound1accDE, question: 'Was ist dir lieber?', answers: ['Rummel', 1, 2, 'Schwimmbad', 2, 3]},
  {id: 2, audio: sound2accDE, question: 'Wie entscheidest du dich?', answers: ['Schießen', 3, 4,'Ansprechen', 4, 5,'Erkunden', 5, 6]},
  {id: 3, audio: sound3accDE, question: 'Bietest du deine Hilfe an?', answers: ['Ja', 7, 7, 'Nein', 6, 6]},
  {id: 4, audio: sound4accDE},
  {id: 5, audio: sound5accDE},
  {id: 6, audio: sound6accDE},
  {id: 7, audio: sound7accDE},
];

const dataAryEN = [
  {id: 1, audio: sound1accEN, question: 'Which do you prefer?', answers: ['Amusement park', 1, 2, 'Public swimming pool', 2, 3]},
  {id: 2, audio: sound2accEN, question: 'What\'s your decision?', answers: ['Shooting', 3, 4,'Addressing the person', 4, 5,'Exploring', 5, 6]},
  {id: 3, audio: sound3accEN, question: 'Are you offering your help?', answers: ['Yes', 7, 7, 'No', 6, 6]},
  {id: 4, audio: sound4accEN},
  {id: 5, audio: sound5accEN},
  {id: 6, audio: sound6accEN},
  {id: 7, audio: sound7accEN},
];

*/
const dataAryEN = dataAryDE;

class InteractiveExample extends React.Component {
    
  audio = null;

  constructor(props){
    super(props);
    this.lang = props.intl.messages["audory.lang"];
    this.state={
      activeNode: 0,
      activeEdge: 0,
      question: 'Demo aus',
      answers: ['Start', 0, 1],
      sound: null,
      currentTime: null,
      isOpen: false,
    };

  }

  componentWillUnmount(){
    this._isUnmounted = true;
    if(this.audio) this.audio.pause();
  }

  start(){
    this.displayNode(1);
  }

  displayNode(id){
    let node = (this.lang==='de' ? dataAryDE : dataAryEN).find((elem) => id === elem.id);
    if(id === 7){
      node.audio = randomAudios[Math.floor(Math.random() * randomAudios.length)];
    }
    this.setState({
      activeNode: id,
      activeEdge: 0,
      currentTime: 0,
      sound: node.audio,
      question: null,
      answers: [],
    });
    
    if(this.audio) this.audio.pause();
    this.audio = new Audio(node.audio);   
    this.audio.onended = (bar, foo) => {
      //Jumpnode
      if(typeof(node.question) === 'undefined' && typeof(node.answers) === 'number'){
        this.displayNode(node.answers);
      } else{
        this.setState({
          question: id < 4 ? node.question : (this.lang === 'de' ? 'Ende erreicht!' : 'End reached!'),
          answers: id < 4 ? node.answers : [(this.lang === 'de' ? 'Nochmal' : 'Play Again'), 0, 1],
        });
      }
    };
    this.audio.ontimeupdate = (bar) => {
      let t = bar.target.currentTime / bar.target.duration;
      if(isNaN(t)) t = 0;
      if(!this._isUnmounted) this.setState({currentTime: t});
    };
    this.audio.load();
    this.audio.play();
  }

  onMouseOverEdge(edge){
    this.setState({activeEdge: edge});
  }

  onMouseLeave(){
    this.setState({activeEdge: 0});
  }

  onToggleAudio(){
    if(this.audio.paused) this.audio.play();
    else this.audio.pause();
  }

  displayAnswers(answers){
    let renderAry=[];
    for(let i=0; i<answers.length; i+=3){
      renderAry.push(
        <Grid.Row key={i+this.state.activeNode*5000} style={{padding: 0, marginTop: i>0 ? '1em' : 0, width: "100%"}}>
          <center>
            <Button
              size={answers[i] === 'Start' ? 'massive' : 'small'}
              color='green'
              icon={answers[i] === 'Start'}
              labelPosition={answers[i] === 'Start' ? 'right' : null}
              onMouseEnter={this.onMouseOverEdge.bind(this, answers[i+1])}
              onMouseLeave={this.onMouseLeave.bind(this)}
              onClick={this.displayNode.bind(this, answers[i+2])}>
                {answers[i]}
                {
                  answers[i] === 'Start' ? (<Icon name='play' />) : null
                }
            </Button>
          </center>
        </Grid.Row>
      );
    }
    return renderAry;
  }
  
    render() {
      return (
        <div style={{textAlign: 'center', marginTop: "1em", padding: "2em"}}>
            <Button color='grey' icon labelPosition='left' compact onClick={() => this.setState({isOpen: !this.state.isOpen})}>
            <Icon name={this.state.isOpen ? 'angle down' : 'angle right'} />
              Was sind interaktive Hörbücher?
            </Button>
          {
            this.state.isOpen && (
              <Segment
                inverted
                vertical
                textAlign='center'
                style={{ padding: '3em 0em', marginTop: '1em', borderRadius: "16px" }}
                >
                  <Container>
                    <Header as='h3' style={{ fontSize: '2em', color: 'white' }}>
                      <FormattedMessage id="audory.interactiveExample.header.head"/>
                    </Header>
                    <p style={{ fontSize: '1.33em' }}>
                      <FormattedMessage id="audory.interactiveExample.header.body"/>
                    </p>
                    <Grid divided inverted stackable align='middle' verticalAlign='middle'>
                      <Grid.Row>
                        <Grid.Column style={{width: '50%'}}>
                          <Diagram
                            activeNode={this.state.activeNode}
                            activeEdge={this.state.activeEdge}
                            currentTime={this.state.currentTime}
                            onToggleAudio={() => this.onToggleAudio()}
                            isPaused={this.audio ? this.audio.paused : false}
                          />
                        </Grid.Column>
                        {
                          this.state.question &&
                            <Grid.Column style={{width: '50%', paddingTop: 0}}>
                              <Grid.Row stretched style={{ display: 'table'}}>
                                  <p style={{color: 'white', fontSize: '2em', display: 'table-cell', verticalAlign: 'middle'}}>
                                    {this.state.question}
                                  </p>
                              </Grid.Row>
                              {this.state.question === "Demo aus" && (
                                <Grid.Row stretched style={{marginTop: '1em'}}>
                                    <Image rounded src={"https://audory-static.s3.eu-central-1.amazonaws.com/nano.jpg"} size='small' />
                                </Grid.Row>
                                    
                                  )}
                              <Grid.Row stretched style={{width: '100%', marginTop: '1em', display: 'table'}}>
                                <Grid textAlign='center' columns={Math.max(this.state.answers.length, 1)} divided style={{display: 'table-cell', verticalAlign: 'middle'}} >
                                  <Grid.Row>
                                    {this.displayAnswers(this.state.answers)}
                                  </Grid.Row>
                                </Grid>
                              </Grid.Row>
                            </Grid.Column>
                        }
                      </Grid.Row>
                    </Grid>
                </Container>
              </Segment>
            )
          }
          
        </div>
      )
    }
  }
  
  
  export default InteractiveExample;



// WEBPACK FOOTER //
// ./src/components/InteractiveExample/InteractiveExample.js